function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExpandLess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "expand_less") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 3697",
    transform: "rotate(180 12 12)",
    style: {
      fill: "none"
    },
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 13h10v-2H7zm5 9a9.732 9.732 0 0 1-3.9-.788A9.978 9.978 0 0 1 2.788 15.9 9.732 9.732 0 0 1 2 12a9.732 9.732 0 0 1 .788-3.9A9.984 9.984 0 0 1 8.1 2.787 9.743 9.743 0 0 1 12 2a9.743 9.743 0 0 1 3.9.787A9.984 9.984 0 0 1 21.212 8.1 9.732 9.732 0 0 1 22 12a9.732 9.732 0 0 1-.788 3.9 9.978 9.978 0 0 1-5.312 5.312A9.732 9.732 0 0 1 12 22z",
    transform: "rotate(180 12 12)",
    style: {
      fill: "#21a2ee"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpandLess);
export default __webpack_public_path__ + "static/media/expand_less.373f65375523d571281f9f567a54c782.svg";
export { ForwardRef as ReactComponent };